import React from 'react';
import { Text } from '@chakra-ui/react';

type Props = {
  message?: string;
};

export function ListEmptyState(props: Props) {
  const message = props.message ?? t('No items to display');
  return (
    <Text color="gray.300" fontStyle="italic">
      {message}
    </Text>
  );
}
